import { ChevronDown, ChevronUp, Plane, Signal } from "lucide-react";
import { toast } from "sonner";

const STATUS_LABELS = {
  moving: "IN TRANSIT",
  idle: "STATIONARY",
  arriving: "ARRIVING",
  offline: "LOCATING SIGNAL",
};

const formatTimeAgo = (isoString, nowDate) => {
  if (!isoString) return "unknown";
  const seconds = Math.max(0, Math.round(((nowDate || new Date()).getTime() - new Date(isoString).getTime()) / 1000));
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ${seconds % 60}s`;
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
};

export const TrackerPanel = ({
  agent,
  now,
  open,
  onToggle,
  follow,
  setFollow,
  setFlyTo,
}) => {
  // Destination name only surfaces for hotels/motels per UX request.
  const showDestination =
    agent &&
    agent.destination_name &&
    (agent.destination_type === "hotel" || agent.destination_type === "motel");

  return (
    <div className={`tracker-panel ${open ? "open" : "collapsed"}`} data-testid="tracker-panel">
      <div className="tracker-header" onClick={onToggle}>
        <span>TRACKED</span>
        {open ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
      </div>
      {open && (
        <div className="tracker-body">
          {!agent ? (
            <div className="empty-state">No active signal…</div>
          ) : (
            <div className="agent-card" data-testid="agent-card">
              <div className="agent-card-row">
                <span className="agent-code-big">{agent.code}</span>
                <button
                  className={`follow-btn ${follow ? "active" : ""}`}
                  onClick={() => {
                    if (follow) { setFollow(false); toast.info("FOLLOW DISENGAGED"); }
                    else { setFollow(true); setFlyTo(agent.location); toast.success(`LOCKED ON ${agent.code}`); }
                  }}
                  data-testid="follow-btn"
                  title={follow ? "Unlock camera" : "Lock camera on agent"}
                >
                  <Signal size={12} />
                </button>
              </div>
              <div className="agent-status-row">
                <span className={`status-pill ${agent.status}`} data-testid="agent-status">
                  {agent.signal_searching && <span className="pulse-dot-red" />}
                  {STATUS_LABELS[agent.status] || agent.status.toUpperCase()}
                </span>
                {agent.status === "moving" && agent.speed > 60 && <Plane size={10} />}
              </div>
              <div className="agent-meta">
                <div>REGION: <strong>{agent.base_name}</strong></div>
                {showDestination && (
                  <div data-testid="agent-destination">
                    DEST: <strong>{agent.destination_name}</strong>
                  </div>
                )}
                <div>SPEED: <strong data-testid="agent-speed">{agent.speed.toFixed(1)} km/h</strong></div>
                {agent.signal_searching && agent.last_seen_at && (
                  <div>SIGNAL LOST: <strong>{formatTimeAgo(agent.last_seen_at, now)} ago</strong></div>
                )}
              </div>
              {agent.signal_searching && (
                <div className="agent-searching-note">
                  Asset last seen in this vicinity.
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
